var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkSuccessBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_16086",
    "data-name": "Gruppe 16086",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_22010",
    "data-name": "Rechteck 22010",
    width: 80,
    height: 80,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_16085",
    "data-name": "Gruppe 16085",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_232657",
    "data-name": "Pfad 232657",
    d: "M40,80h-.024A40,40,0,0,1,40,0h.023A39.747,39.747,0,0,1,56.281,3.463a1,1,0,0,1-.816,1.83A37.739,37.739,0,0,0,40.022,2H40A38,38,0,0,0,39.978,78H40A38,38,0,0,0,78,40.022V36.434a1,1,0,0,1,2,0v3.588A40,40,0,0,1,40,80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_232658",
    "data-name": "Pfad 232658",
    d: "M40,48.861a1.007,1.007,0,0,1-.708-.292l-11.7-11.7a1,1,0,1,1,1.416-1.416L40,46.444,78.29,8.116a1,1,0,0,1,1.418,1.415l-39,39.036a1,1,0,0,1-.708.294",
    fill: "#d1d3d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkSuccessBig);
export default __webpack_public_path__ + "static/media/checkmark_success_big.6ad2bb78273f2f811b2b5766b2a6c2dc.svg";
export { ForwardRef as ReactComponent };